import reducer from './reducers';
import * as cliniciansActions from './actions';
import * as cliniciansSelectors from './selectors';

export { cliniciansActions, cliniciansSelectors };
export default reducer;